// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { DdjDocumentCore } from '@interfaces/document.interfaces';
import { DocumentsService } from '@services/documents.service';
import { Observable } from 'rxjs';
import { UserService } from '../user.service';

@Injectable({
    providedIn: 'root',
})
export class TemplateListResolver implements Resolve<DdjDocumentCore[]> {
    constructor(
        private documentService: DocumentsService,
        private userService: UserService
    ) {}

    resolve(route: ActivatedRouteSnapshot): Observable<DdjDocumentCore[]> {
        const filterResult = route?.url[0]?.path?.includes('forms') ? true : false;
        return this.documentService.getTemplateBasicList$(filterResult, this.userService.user.dealerId);
    }
}
